import { createWizardContext } from '@/modules/common/components/wizard';
import { ConsolidationFormState, ConsolidationPageKeys } from './types';

export const consolidationWizardContext = createWizardContext<
  ConsolidationFormState,
  ConsolidationPageKeys
>();
